import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { AddressVerifyStatus } from 'api';

@Component({
  selector: 'ss-stx-shared-address-verification-check',
  templateUrl: './address-verification-check.component.html',
  styleUrls: ['./address-verification-check.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressVerificationCheckComponent implements OnInit {
  @Input() addressStatus?: AddressVerifyStatus;

  iconColor = 'none';
  verificationStatus = '';
  ngOnInit(): void {
    this.iconColor = this.addressStatusToIconColor(this.addressStatus);
    this.verificationStatus = this.addressStatusToTooltip(this.addressStatus);
  }

  private addressStatusToIconColor(status?: AddressVerifyStatus): string {
    switch (status) {
      case 'EXPIRED':
        return 'yellow';
      case 'FAILED':
        return 'red';
      case 'UNEXPIRED':
        return '#60cc64';
      case 'UNVERIFIED':
        return 'white';
      default:
        return 'none';
    }
  }

  private addressStatusToTooltip(status?: AddressVerifyStatus): string {
    switch (status) {
      case 'EXPIRED':
        return 'Verified - Expired';
      case 'FAILED':
        return 'Verified - Failed';
      case 'UNEXPIRED':
        return 'Verified - Good Standing';
      case 'UNVERIFIED':
        return 'Unverified';
      default:
        return 'none';
    }
  }

  onMouseEnter(addressVerificationTooltip: HTMLElement) {
    addressVerificationTooltip.style.display = 'block';
  }

  onMouseLeave(addressVerificationTooltip: HTMLElement) {
    addressVerificationTooltip.style.display = 'none';
  }
}
